module.exports = __webpack_public_path__ + "static/suman-8914daaffd57c1e04eb7c7bb4136b5f2.png";